import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "@/redux/apiSlice";
import authReducer from "@/redux/authSlice";
import counterReducer from "@/redux/counterSlice";
import invoiceReducer from "@/redux/invoiceSlice";
import sidePanelReducer from "@/redux/sidePanelSlice";
import walletReducer from "@/redux/walletRefundSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    counter: counterReducer,
    invoice: invoiceReducer,
    wallet: walletReducer,
    sidePanel: sidePanelReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      apiSlice.middleware,
    ),
});

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];

export default store;
